import React, { useEffect, useRef, useState } from 'react';
import './ImagePrompt.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import ImagePreview from './ImagePreview';
import ButtonSidebar from './ButtonSidebar/ButtonSidebar';
import { useHistory, Prompt } from 'react-router-dom';
import arrowSVG from './Iconos/arrow.svg';
import playSVG from './Iconos/play.svg';
import checkSVG from './Iconos/check.svg';
import exampleImage1 from './Imagenes/ejemplo1.png';
import exampleImage2 from './Imagenes/ejemplo2.png';
import exampleImage3 from './Imagenes/ejemplo3.png';
import exampleImage4 from './Imagenes/ejemplo4.png';
import ImageCrop from './ImageCrop';
import ImageEditor from './ImageEditor'; // Asegúrate de que la ruta sea correcta

const VALID_MINUTES = 35; // Images are saved for 35 minutes

function ImagePrompt() {
  const history = useHistory();
  const { t } = useTranslation();
  const [prompt, setPrompt] = useState('');
  const [selectedImage, setSelectedImage] = useState<string>('');
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [progress, setProgress] = useState(0); // Estado para el progreso del "progress bar"
  const DescribeImage = t('DescribeImage');
  const userId = localStorage.getItem('userId') || 'defaultUserId';
  const [showCrop, setShowCrop] = useState(false);
  const [isProcessStarted, setIsProcessStarted] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [overlayText, setOverlayText] = useState(''); // Para el texto a añadir
  const [showEditor, setShowEditor] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsGenerating(true);
    setProgress(0); // Reiniciar el progreso al enviar
    setIsProcessStarted(true); // Marcar que el proceso ha comenzado

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No hay token de autenticación disponible');
      }

      // Primero, restamos los créditos
      const creditosResponse = await axios.post(`${backendUrl}/restar-creditos`, {
        cantidad: 3 // Restamos 3 créditos por generar imagen
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('Respuesta de restar créditos:', creditosResponse.data.succes); // Log para verificar respuesta

      if (creditosResponse.data.success) {
        console.log("se genera la imagen");
        // **Generar la imagen después de restar los créditos correctamente**
        const response = await axios.post(`${backendUrl}/generate-image`, { prompt }, {
          headers: {
            'Authorization': `Bearer ${token}` // Incluir el token también en esta solicitud si es necesario
          }
        });

        console.log('Respuesta de generación de imagen:', response.data);

        if (response.data.images && response.data.images.length) {
          const imageData = {
            timestamp: new Date().getTime(),
            images: response.data.images,
          };
          localStorage.setItem('imageData', JSON.stringify(imageData));
          setThumbnails(response.data.images);
          setSelectedImage(response.data.images[0]);
        } else {
          console.error("No images returned from the API");
        }
      } else {
        alert(creditosResponse.data.mensaje);  // Mensaje proporcionado por el backend
      }
    } catch (error) {
      console.error("Error generando imagen o actualizando créditos:", error);
      alert('Ha ocurrido un error al restar créditos o generar la imagen.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleAddTextToImage = () => {
    setShowEditor(true);
  };


  useEffect(() => {
    // Verificar si el usuario está autenticado
    const userId = localStorage.getItem('userId');
    if (!userId) {
      // Redirigir a la página de inicio de sesión si no está autenticado
      history.push('/PantallaInicial');
    }
  }, [history]);

  useEffect(() => {
    setThumbnails([exampleImage1, exampleImage2, exampleImage3, exampleImage4]);
    setSelectedImage(exampleImage1);
  }, []);

  useEffect(() => {
    if (isGenerating) {
      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prevProgress + 1.67; // Incremento del progreso para completar en 60 segundos (100 / 60 ≈ 1.67)
        });
      }, 1000); // Actualizar cada segundo
    }
  }, [isGenerating]);

  const handleSelectImage = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    localStorage.setItem('selectedImage', imageUrl);
  };

  useEffect(() => {
    const imageDataJSON = localStorage.getItem('imageData');
    if (imageDataJSON) {
      const imageData = JSON.parse(imageDataJSON);
      const timeNow = new Date().getTime();
      const timeElapsed = (timeNow - imageData.timestamp) / 1000 / 60; // Time in minutes

      if (timeElapsed < VALID_MINUTES) {
        setThumbnails(imageData.images);
        setSelectedImage(imageData.images[0]);
      } else {
        localStorage.removeItem('imageData'); // Images expired
      }
    }
  }, []);

  // Controlar navegación sin advertencia para rutas específicas
  const handleNavigation = (nextPath: string) => {
    history.push(nextPath);
  };

  const handlePreviousClick = () => {
    handleNavigation('/');
  };

  const handleNextClick = () => {
    handleNavigation('/Social-Networking2');
  };

  const handleSaveDraft = async (imageUrl: string) => {
    const token = localStorage.getItem('token'); // Assuming you save the token in localStorage
    if (!token) {
      alert('No estás autenticado.');
      return;
    }

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);

      const response = await axios.post(`${backendUrl}/save-drafts`, {
        userId,
        images: [imageUrl]
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      alert('Borrador guardado con éxito');
    } catch (error) {
      console.error('Error al guardar el borrador:', error);
      alert('Error al guardar el borrador');
    }
  };

  const handleCropComplete = (croppedImageUrl: string) => {
    setSelectedImage(croppedImageUrl);
    setShowCrop(false);
  };

  const handleCropClick = () => {
    setShowCrop(true);
  };

  return (
    <div className='container-text'>
      <Prompt
        when={isProcessStarted}
        message={(location) =>
          location.pathname === '/Social-Networking2' || location.pathname === '/'
            ? true
            : '¿Estás seguro de que quieres salir? Se han descontado 3 créditos por este proceso.'
        }
      />
      <div className='img-container'>
        <div className="thumbnails-container">
          <ImagePreview thumbnails={thumbnails} onSelect={handleSelectImage} />
        </div>
        <div className="image-prompt-container">
          <div className="image-gallery-container"></div>
          <div className="image-prompt-title">
            <p>{t('imagePrompt.describeYourImage')} <span className="highlight">{t('imagePrompt.ImageHere')}</span>.</p>
          </div>
          <div className="image-prompt-description">
            <form onSubmit={handleSubmit}>
              <input
                className='input-prompt'
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder={DescribeImage}
              ></input>
              <button className="image-prompt-button" type="submit">
                <span className="image-prompt-button-icon"><img src={playSVG} alt="" /> </span>
                {t('imagePrompt.create')}
              </button>
            </form>
          </div>
        
          {isGenerating && (
            <div className="loading-container">
              <div className="loading-indicator">{t('Generando imágenes...')}</div>
              <div className="progress-bar">
                <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
              </div>
            </div>
          )}
          <div className="main-image-container">
            {selectedImage && <img src={selectedImage} alt="Selected" className={`main-image ${selectedImage === selectedImage ? 'thumbnail-selected' : ''}`} />}

            <div className="image-selection-navigation">
              <button className="image-selection-previous" onClick={handlePreviousClick}>
                <img src={arrowSVG} alt="" className='reverse-arrow' /> {t('Anterior')}
              </button>
              <button className="image-selection-next" onClick={handleNextClick}>
                {t('Siguiente')} <img src={arrowSVG} alt="" className='normal-arrow' />
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCrop && <ImageCrop imageUrl={selectedImage} onCropComplete={handleCropComplete} />}
      <ButtonSidebar selectedImage={selectedImage} onSaveDraft={handleSaveDraft} onCropClick={handleCropClick} />
    </div>
  );
}

export default ImagePrompt;
